import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { modalTypes, modalActions } = createActionsStructure('modal', [
  { name: 'SHOW_MODAL', async: false },
  { name: 'HIDE_MODAL', async: false },
  { name: 'CONFIRM_ACTION', async: false },
  { name: 'CANCEL_ACTION', async: false }
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/ModalActions.js